import { useGrowthOverviewContext } from "../context/GrowthOverviewProvider";

import { useGrowthOverviewLazyTree } from "./useGrowthOverviewLazyTree";

export const useGrowthOverviewTableRows = () => {
    const { granularity, metric, debouncedSearchTerm } = useGrowthOverviewContext();

    return useGrowthOverviewLazyTree(granularity, metric, debouncedSearchTerm);
};
